const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 3796",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 52.145,
    viewBox: "0 0 39 52.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5725",
    d: "M106.542 0h17.448l14.769 15.409v29.953a6.783 6.783 0 0 1-6.783 6.783h-25.434a6.783 6.783 0 0 1-6.783-6.783V6.783A6.783 6.783 0 0 1 106.542 0z",
    transform: "translate(-99.759)",
    style: {
      fill: "#f6b119"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3795"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5726",
    d: "M467.212 0v15.282H482z",
    transform: "translate(-443.003)",
    style: {
      fill: "#885a06",
      fillRule: "evenodd",
      opacity: 0.302
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5727",
    d: "M195.356 440.947v-8.632h3.058a5.574 5.574 0 0 1 1.708.26 4.7 4.7 0 0 1 1.434.766 3.424 3.424 0 0 1 1.012 1.35 5.237 5.237 0 0 1 0 3.88 3.423 3.423 0 0 1-1.012 1.35 4.7 4.7 0 0 1-1.434.766 5.574 5.574 0 0 1-1.708.26zm2.158-1.877h.64a3.706 3.706 0 0 0 .956-.12 2.733 2.733 0 0 0 .815-.394 1.71 1.71 0 0 0 .59-.759 2.811 2.811 0 0 0 .218-1.167 2.87 2.87 0 0 0-.218-1.174 1.729 1.729 0 0 0-.59-.752 2.576 2.576 0 0 0-.815-.394 3.706 3.706 0 0 0-.956-.12h-.64zm10.664 1.975a4.415 4.415 0 0 1-3.227-1.258 4.551 4.551 0 0 1 0-6.312 4.415 4.415 0 0 1 3.227-1.258 4.367 4.367 0 0 1 3.191 1.258 4.569 4.569 0 0 1 0 6.312 4.367 4.367 0 0 1-3.191 1.258zm-1.659-2.594a2.237 2.237 0 0 0 3.283 0 2.911 2.911 0 0 0 0-3.641 2.237 2.237 0 0 0-3.283 0 2.886 2.886 0 0 0 0 3.641zm11.247 2.594a4.427 4.427 0 0 1-3.135-1.167 4.811 4.811 0 0 1 .014-6.488 4.439 4.439 0 0 1 3.121-1.174 4.386 4.386 0 0 1 2.756.829 3.1 3.1 0 0 1 1.237 2.193l-2.179.443a1.951 1.951 0 0 0-.647-1.153 1.765 1.765 0 0 0-1.181-.436 2.026 2.026 0 0 0-1.547.661 3.132 3.132 0 0 0-.007 3.747 2.012 2.012 0 0 0 1.553.668 1.792 1.792 0 0 0 1.153-.38 1.666 1.666 0 0 0 .6-1.012l2.228.506a3.276 3.276 0 0 1-1.357 2.031 4.458 4.458 0 0 1-2.609.732z",
    transform: "translate(-189.058 -403.739)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.f6abab25cee5f6d44a138f139e581c20.svg";
export { ForwardRef as ReactComponent };